import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { UserSearchState } from '../models/user.models';
import * as selectors from '../selectors/user-search.selectors';

@Injectable({ providedIn: 'root' })
export class UserSearchFacadeService extends FacadeService {
  constructor(public override store: Store<UserSearchState>) {
    super(store);
  }

  panelExpanded$ = this.storeSelect(selectors.getPanelExpanded);
  userName$ = this.storeSelect(selectors.getUserName);
  displayedName$ = this.storeSelect(selectors.getDisplayedName);
  email$ = this.storeSelect(selectors.getEmail);
  securityGroup$ = this.storeSelect(selectors.getSecurityGroup);
  businessGroup$ = this.storeSelect(selectors.getBusinessGroup);
  deactivated$ = this.storeSelect(selectors.getDeactivated);
  quicksight$ = this.storeSelect(selectors.getQuicksight);
  securityGroupValues$ = this.storeSelect(selectors.getSecurityGroupValues);
  businessGroupValues$ = this.storeSelect(selectors.getBusinessGroupValues);
  securityGroupId$ = this.storeSelect(selectors.getSecurityGroupId);
  businessGroupId$ = this.storeSelect(selectors.getBusinessGroupId);
  rawSecurityGroups$ = this.storeSelect(selectors.getRawSecurityGroups);
  rawBusinessGroups$ = this.storeSelect(selectors.getRawBusinessGroups);
  searchEnabled$ = this.storeSelect(selectors.getSearchEnabled);

  get panelExpanded() {
    return this.storeSnapshot(this.panelExpanded$);
  }

  get userName() {
    return this.storeSnapshot(this.userName$);
  }

  get displayedName() {
    return this.storeSnapshot(this.displayedName$);
  }

  get email() {
    return this.storeSnapshot(this.email$);
  }

  get securityGroup() {
    return this.storeSnapshot(this.securityGroup$);
  }

  get rawSecurityGroups() {
    return this.storeSnapshot(this.rawSecurityGroups$);
  }

  get rawBusinessGroups() {
    return this.storeSnapshot(this.rawBusinessGroups$);
  }

  get quicksight() {
    return this.storeSnapshot(this.quicksight$);
  }

  get businessGroup() {
    return this.storeSnapshot(this.businessGroup$);
  }

  get deactivated() {
    return this.storeSnapshot(this.deactivated$);
  }

  get securityGroupId() {
    return this.storeSnapshot(this.securityGroupId$);
  }

  get businessGroupId() {
    return this.storeSnapshot(this.businessGroupId$);
  }
}
